import {IconProps} from 'platform/foundation';

export type ActionDefinition = {
  /** Action title shown in action dropdown */
  title: string;
  /** Action description shown in tooltip */
  description?: string;
  /** Icon shown in standalone action */
  icon: IconProps;
  /** Defines if action can be used for bulk operations */
  bulkAction: boolean;
  /** Defines if action can be used for single operation on row */
  singleAction: boolean;
  /** Defines if action have to be confirmed (in form of inline confirm) */
  confirm: boolean;
  /** Variant of an button to be applied */
  variant: string;
  /** defines group name to be shown in dropdown */
  group?: string;
  /** Defines if the action serves as a link to another page */
  isLink: boolean;
};

export type ActionKey = string;

export type ActionDefinitionObject = Record<ActionKey, ActionDefinition>;
